import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
} from '@angular/forms';

/**
 * Zip code must be 5 characters in length and all numbers.
 *
 * @usageNotes
 * Can be used with reactive forms and with template-driven forms.
 *
 * @selector appZipCode
 * @returns
 * ```javascript
 * { zipInvalid: true } | null
 * ```
 */
@Directive({
  selector: '[appZipCode]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ZipCodeDirective,
      multi: true,
    },
  ],
})
export class ZipCodeDirective {
  @Input('appZipCode') zipCode = '';

  constructor() {}

  validate(control: AbstractControl): ValidationErrors | null {
    return this.zipCode ? zipCodeValidator(control) : null;
  }
}

export const ZIP_VALID_REGEX = /^(\d{5})$/;

/**
 * Zip code must be 5 characters in length and all numbers.
 *
 * @returns
 * ```javascript
 * { zipInvalid: true } | null
 * ```
 */
export const zipCodeValidator = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;
  const zipValid = ZIP_VALID_REGEX.test(value);

  return !zipValid ? { zipInvalid: true } : null;
};
